module.exports = __webpack_public_path__ + "media/sound_error.9f9704bc.mp3";